import fetch from 'isomorphic-fetch';
import Constants from '../definitions/constants';
import InterfaceTooling from '../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../tooling/javascriptUtilsTooling';

const AssignTableTooling = {
  handleClickOnAssignParent: async (event, getQueryParamsFunction, fetchListFunction, topControlsState) => {
    let entity = JSON.parse(event.currentTarget.dataset.entitydata);
    topControlsState.assignSearchText = "";
    await fetchListFunction(Object.assign(getQueryParamsFunction(),
      { id: entity.id, name: entity.name }
    ));
  },
  getListQueryParams: (listState, searchText) => {
    return {
      page: listState.page,
      per_page: listState.pageSize,
      search: searchText!="" ? searchText : null,
      id: listState.assignId,
      name: listState.assignName
    };
  },
  fetchListNextPage: async (event, listState, getQueryParamsFunction, fetchListFunction) => {
    var page = +event.currentTarget.dataset.targetpage;
    if(listState.status === 200 && listState.page<=listState.totalPages) {
      await fetchListFunction(Object.assign(getQueryParamsFunction(), {
        page: page,
      }), true);
    }  
  },
  fetchListSearch: async (event, getQueryParamsFunction, fetchListFunction) => {
    await fetchListFunction(Object.assign(getQueryParamsFunction(),{
      page: 1,
    }));
  },
  handleOnChangeTopControls: (event, state, topControlsStateName, fetchListSearch, timeoutObject) => {
    let topControlsFormData = { ...state[topControlsStateName] };
    let value = JavascriptUtilsTooling.getInputValueFromEvent(event);
    let returnState = {};
    
    topControlsFormData[event.currentTarget.id] = value;
    returnState[topControlsStateName] = topControlsFormData;
    state.searchTimeoutObject = InterfaceTooling.delayCallAction(fetchListSearch, timeoutObject);
    
    return returnState;
  },
  handleCheckBoxClick: async (event, saveAssign, periodId = null) => {
    let assignId = event.currentTarget.dataset.assignid;
    let assignEntity = JSON.parse(event.currentTarget.dataset.assignentity);
    let action = event.currentTarget.checked;
    let params = {
      id: assignId,
      related_entity_id: assignEntity.id,
      add: action
    };
    if(periodId != null) {
      params.period_id = periodId;
    }
    await saveAssign(params);  
  },
  feedbackMessages: (prevProps, props, saveMode1PropsPath, saveMode2PropsPath) => {  
    //handle save feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps[saveMode1PropsPath].status, prevProps[saveMode2PropsPath].status],
      [props[saveMode1PropsPath].status, props[saveMode2PropsPath].status],
      intl.formatMessage({ id: "common.assign.assignSuccess" }),
      intl.formatMessage({ id: "common.assign.assignError" })
    );
    //handle imoprt feedback
    InterfaceTooling.apiCallResultFeedback(
      [prevProps.downloadImport.status],
      [props.downloadImport.status],
      intl.formatMessage({ id: "common.assign.downloadImportFileSuccess" }),
      intl.formatMessage({ id: "common.assign.downloadImportFileFailure" })
    );
  }
};

export default AssignTableTooling;


// WEBPACK FOOTER //
// ./source/tooling/assignTableTooling.js